import dayjs from 'dayjs';
import utcPlugin from 'dayjs/plugin/utc';
import timezonePlugin from 'dayjs/plugin/timezone';
dayjs.extend(utcPlugin);
dayjs.extend(timezonePlugin);
import { DEPRECATED_TIMEZONES } from '../contants';
var convertByTimezone = function (utcISODate, timezoneName) {
    if (timezoneName === void 0) { timezoneName = 'UTC'; }
    try {
        var timezone = DEPRECATED_TIMEZONES[timezoneName] || timezoneName;
        return (dayjs.utc(utcISODate).tz(timezone).format('YYYY-MM-DDTHH:mm:ss.SSS') + "Z");
    }
    catch (err) {
        return utcISODate;
    }
};
export default convertByTimezone;
